module.exports = __webpack_public_path__ + "static/media/1012716.c436e28a.jpg";